module.exports = __webpack_public_path__ + "static/media/vl4.48fffb73.jpeg";